import React, { Component } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import _ from 'lodash';
import * as d3 from 'd3';
import numeral from 'numeral'

import WorldMap from '../charts/WorldMap/WorldMapComponent'
import countryDataOriginal from './countryData.json'

const countryData = countryDataOriginal
  .filter(c => c.Country !== 'Gibraltar')
  .map(c => ({ 
    ...c, 
    medicalUse: (+c.Codeine || 0) + (+c.Fentanyl || 0) + (+c.Hydrocodone || 0) + (+c.Hydromorphone || 0) + (+c.Morphine || 0) + (+c.Oxycodone || 0) 
  }))
const styles = {
  main: {
    //padding: '70vh 2vw',
    display: 'flex',
    fontFamily: 'Open Sans',
    justifyContent: 'space-between',
    position: 'relative',
  },
  /*test: {
    padding: 35,
    backgroundImage:
      `linear-gradient(to bottom,
        rgba(240, 255, 40, 1) 0%,
        rgba(240, 255, 40, 1) 100%),
      linear-gradient(to bottom,
        rgba(240, 40, 40, 1) 0%,
        rgba(240, 40, 40, 1) 100%)`,
    backgroundClip: 'content-box, padding-box',
  },*/
  btnContainer: {
    position: 'fixed',
  },
  btn: {
    padding: '8px 10px',
    fontSize: '14px',
    margin: '10px',
    fontFamily: 'Open Sans',
  },
  graphic: {
    //flexBasis: '100%',
    position: 'sticky',
    /*position: '-webkit-sticky',
    position: '-moz-sticky',
    position: '-ms-sticky',
    position: 'sticky',
    position: '-webkit-sticky',*/
    //width: '75%',
    //padding: '5rem 0',
    top: '0',
    //alignSelf: 'flex-end',
    marginLeft: '35%',
    width: '65%',
    //backgroundColor: '#aaa',
    paddingTop: '10vh',
    height: '80vh'
  },
  scroller: {
    pointerEvents: 'none',
    zIndex: 100,
    flexBasis: '35%',
  },
  step: {
    fontFamily: 'tex-gyre-schola', 
    fontSize: 18,
    lineHeight: '1.2',
    color: 'black',
    margin: '2rem 2rem 2rem 2rem',
    textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white',
    paddingTop: 200,
    paddingBottom: 200,
    //border: '1px solid #333',
    pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'career', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px',
    backgroundColor: '#ffffffc7'
  },
  quoted: {
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px',
    backgroundColor: '#ffffffc7'
  }
};

export default class CountrySituation extends Component {
  constructor(props) {
    super(props);
    this.state = { step: 0, width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onStepEnter = ({ element, data, direction }) => {
    //element.style.backgroundColor = 'lightgoldenrodyellow';
    this.setState({ step: data, direction });
  };

  onStepExit = ({ element, data, direction }) => {
    if(this.state.step === 1 && direction === 'up' ) this.setState({ step: 0, direction });
    //element.style.backgroundColor = '#fff';
  };

  render() {
    const { step, width, height } = this.state;

    const numberOfColors = 8
    const scheme = d3.schemeRdPu[numberOfColors]
    const thresholds = [0,1500,5000,10000,15000,19000,26000,35000];
    const colorScale = d3.scaleThreshold()
      .domain(thresholds)
      .range(scheme)

    const consoMax = _.maxBy(countryData, c => c.medicalUse).medicalUse
    const topCountries = _.sortBy(countryData, c => -c.medicalUse).slice(0, 39)
      .map(c => ({
        name: c.Country,
        value: c.medicalUse,
        proportion: c.medicalUse/consoMax,
        color: colorScale(c.medicalUse)
      }))
    return (
      <div>
        <div>
          <div style={styles.main}>
            <div style={{ ...styles.scroller, flexBasis: width < 900 ? '100%' : '35%' }}>
              <Scrollama
                offset={0.33}
                onStepEnter={this.onStepEnter}
                onStepExit={this.onStepExit}
                //debug
              >
                <Step data={1}>
                  <div style={{...styles.step, height: '100vh' }}>
                    <div style={styles.p}>
                      The industrialised country under opioids.
                    </div>
                    <h4 style={{...styles.quoted, paddingBottom: 16 }}>USA, Europe and Oceania are the biggest consumers of opioid drugs. That being said, this may correspond, in part, to adequate pain management. In the rest of the world, under-consumption of opioids can also mean untreated pain.</h4>
                  </div>
                </Step>
                <Step data={2}>
                  <div style={{...styles.step }}>
                    <div style={styles.p}>
                      Belgium in the lead pack. 
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>The five countries with the highest average opioid consumption from 2015 to 2017 are the United States, Germany, Austria, Canada, and ... Belgium. <br/>The Belgian consumes half as much opioids as the American but twice as much as the English or French.</div>
                    <div style={{ ...styles.quoted, paddingBottom: 16, fontSize: 16, fontFamily: 'Open Sans' }}>
                      {
                        topCountries.map((country, i) => (
                          <div key={country.name}>
                            <div style={{ whiteSpace: 'nowrap', backgroundColor: country.color, textShadow: 'none', paddingLeft: 4, marginBottom: 4, width: `${Math.round(country.proportion * 100)}%` }}><span style={{ color: i >= 15 ? 'grey' : 'white', mixBlendMode: 'screen' }}>{country.name} – {numeral(country.value).format("0.0a")}</span></div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </Step>
              </Scrollama>
            </div>
            <div style={{ position: 'absolute', top: 0, bottom: 0, width: '100%'}}>
              {/*<div style={styles.graphic}>*/}
              <div className="graphic" style={{ 
              marginLeft: width < 900 ? '0%' : '35%', 
              width: width < 900 ? '100%' : '65%',
              paddingTop: width < 900 ? '20vh' : '10vh',
              height: width < 900 ? '50vh' : '80vh',
              }}>
                {/*<div>Step: {step} – Direction: {direction} </div>*/}
                {height && <WorldMap 
                    view={step > 1 ? 'grid' : 'classic'}
                    valueAccessor="medicalUse"
                    countryCodeType="name"
                    countryCodeAccessor="Country"
                    data={countryData}
                  />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CountrySituation/CountrySituation.js